import { Language } from 'vvs-uikit'
import { EN, languages } from 'config/localization/languages'
import { getUrlSearch } from 'utils/urlSearch'
import { ContextData } from './types'

const publicUrl = process.env.PUBLIC_URL

export const LS_KEY = 'pancakeswap_language'
export const LS_SEARCH_KEY = 'locale'

export const fetchLocale = async (locale: string) => {
  const response = await fetch(`${publicUrl}/locales/${locale}.json`)
  const data = await response.json()
  return data
}

export const getInitLanguageCode = () => {
  try {
    const localeFromSearch = getUrlSearch(window.location.search, LS_SEARCH_KEY)
    const codeFromStorage = localStorage.getItem(LS_KEY)

    return [localeFromSearch, codeFromStorage].find((l) => languages[l]) || EN.locale
  } catch {
    return EN.locale
  }
}

export const translate = (
  languageMap: Map<Language['locale'], Record<string, string>>,
  currentLanguage: Language,
  key: string,
  data?: ContextData,
) => {
  const translationSet = languageMap.has(currentLanguage.locale)
    ? languageMap.get(currentLanguage.locale)
    : languageMap.get(EN.locale)
  const translatedText = translationSet?.[key] || key

  // Check the existence of at least one combination of %%, separated by 1 or more non space characters
  const includesVariable = translatedText.match(/%\S+?%/gm)

  if (includesVariable && data) {
    let interpolatedText = translatedText
    Object.keys(data).forEach((dataKey) => {
      const templateKey = new RegExp(`%${dataKey}%`, 'g')
      interpolatedText = interpolatedText.replace(templateKey, data[dataKey].toString())
    })

    return interpolatedText
  }

  return translatedText
}
